module.exports = __webpack_public_path__ + "img/plane-icon.5449cd83.png";